const INITIAL_QUESTION = "1"

export default {
  INITIAL_QUESTION,
}
